/** Legacy PropertyTransaction helpers. */
import { add, ZERO, type Decimal } from '../core/decimal.ts';
import type { Property, PropertyCostBreakdown } from '../types/domain.ts';

const breakdownTotal = (b: PropertyCostBreakdown): Decimal =>
  [b.insurance, b.maintenance, b.groundRent, b.serviceCharge].reduce(add, b.councilTax);

/** totalMonthlyCosts: monthlyCosts, else the breakdown total, else 0 (the mortgage is a separate debt). */
export const propertyMonthlyCosts = (property: Property): Decimal =>
  property.monthlyCosts ?? (property.costBreakdown === null ? ZERO : breakdownTotal(property.costBreakdown));
